<template>
<div style="padding: 1rem; display: flex; justify-content: space-between">
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item class="text-font" v-for="item in levelList" :key="item.path" :to="item.path">{{item.meta.title}}</el-breadcrumb-item>
  </el-breadcrumb>
  <el-dropdown @command="menuClick">
    <div style="display: flex; align-items: center">
      <el-avatar icon="el-icon-user-solid"/>
      <span class="el-dropdown-link" style="margin-left: 0.6rem">
    黄修勇<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
    </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="switchMerchant">切换商家 <i class="el-icon-arrow-right"></i></el-dropdown-item>
        <el-dropdown-item command="addMerchant">添加商家 <i class="el-icon-arrow-right"></i></el-dropdown-item>
        <el-dropdown-item command="modifyPassword">修改密码 <i class="el-icon-arrow-right"></i></el-dropdown-item>
        <el-dropdown-item command="feedback">系统反馈 <i class="el-icon-arrow-right"></i></el-dropdown-item>
        <el-dropdown-item command="logout">注销登录 <i class="el-icon-arrow-right"></i></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
</div>
</template>

<script>
export default {
  name: 'navBar',
  data () {
    return {
      levelList: []
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  created () {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb () {
      let matched = this.$route.matched.filter(item => item.name)
      console.log(matched)
      const first = matched[0]
      if (first && first.name.trim().toLocaleLowerCase() !== 'home') {
      }
      this.levelList = matched
    },
    menuClick (cmd) {
      this.$emit(cmd)
    }
  }
}
</script>

<style scoped>
.text-font{
  font-size: 1.4rem;
}

</style>



// WEBPACK FOOTER //
// src/components/navBar/navBar.vue